import useCircularArray from './useCircularArray'

export const changeSpeed = () => {
  const { value: speed, next: nextSpeed } = useCircularArray<number>([
    1,
    1.2,
    1.5,
    2,
    0.5,
    0.8
  ])
  return {
    speed,
    nextSpeed
  }
}
